import { CalendarDays } from "lucide-react";
import { useState, useEffect } from "react";

const CountdownPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  // ✅ Show only once per session
  useEffect(() => {
    const hasShown = sessionStorage.getItem("countdownShown");

    if (!hasShown) {
      setIsOpen(true);
      sessionStorage.setItem("countdownShown", "true");
    }
  }, []);

  // ✅ Auto close after 2 seconds
  useEffect(() => {
    if (!isOpen) return;

    const timer = setTimeout(() => {
      setIsOpen(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50 px-4">
      <div className="relative w-full max-w-md bg-white rounded-3xl shadow-2xl p-6 sm:p-8 text-center">

        {/* Close Button */}
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold flex items-center justify-center transition"
        >
          ✕
        </button>

        {/* Logos */}
        <div className="flex justify-between items-center mb-6 gap-3">
          <img
            src="https://pdpl-stuff.s3.ap-south-1.amazonaws.com/dynamic/ksshospitals.com/FwEUA73pIY.jpg"
            alt="Glee Biotech Ltd."
            className="h-10 object-contain"
          />
          <img
            src="https://pdpl-stuff.s3.ap-south-1.amazonaws.com/dynamic/ksshospitals.com/AiqrHIBvOY.png"
            alt="ISCCM 2026"
            className="h-10 object-contain"
          />
        </div>

        {/* Heading */}
        <h2 className="text-base font-semibold text-gray-900 mb-3">
         ISCCM - CRITICARE 2026 – A Successful Collaboration! 
        </h2>

        {/* Partner Info */}
        <p className="text-sm sm:text-base text-gray-700 mb-4">
          <strong>Glee Biotech Ltd.</strong> is proud Academic Partner at <br />
          <strong>ISCCM 2026</strong>
        </p>

        {/* Location */}
        <div className="bg-gradient-to-r from-cyan-100 to-emerald-100 text-emerald-800 text-sm font-medium rounded-xl py-2 px-4 mb-5">
          📍 Chennai Trade Centre, Chennai
        </div>

        {/* Description */}
        <p className="text-sm text-gray-600 mb-4 leading-relaxed">
          Heartfelt thanks to all Delegates
        </p>

        {/* Date & Stall */}
        <div className="flex items-center justify-center gap-3 text-sm text-gray-700 font-medium">
          <span className="flex items-center gap-2">
            <CalendarDays className="w-4 h-4 text-blue-600" />
            27 Feb – 1 Mar 2026
          </span>
          <span className="text-gray-300">|</span>
          <span className="font-semibold text-gray-800">
            at Stall 9 & 10
          </span>
        </div>

      </div>
    </div>
  );
};

export default CountdownPopup;